import { render, staticRenderFns } from "./logManage.vue?vue&type=template&id=8dc22642&scoped=true&"
import script from "./logManage.vue?vue&type=script&lang=js&"
export * from "./logManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc22642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dc22642')) {
      api.createRecord('8dc22642', component.options)
    } else {
      api.reload('8dc22642', component.options)
    }
    module.hot.accept("./logManage.vue?vue&type=template&id=8dc22642&scoped=true&", function () {
      api.rerender('8dc22642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/logManage/logManage.vue"
export default component.exports